import React from 'react';
import photo1 from '../../../resources/img/rotheras2025.jpg';

function About() {
    return (
        <div>
            <section id="about-company" className="py-20">
                <div className="max-w-7xl mx-auto px-6">
                    <div className="text-center mb-16">
                        <h2 className="text-5xl font-serif font-bold text-gray-800 mb-6">About Rotheras</h2>
                        <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
                            Η εταιρεία μας προσανατολίζεται στο χώρο της χειροποίητης εσωτερικής διακόσμησης, οργάνωσης
                            και αποθήκευσης. Η ιδέα και ο στόχος μας είναι να δημιουργούμε χειροποίητα προϊόντα
                            συμβάλλοντας στην υποστήριξη και αναβίωση της τέχνης της ελληνικής κλωστοϋφαντουργίας.

                        </p>
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
                        <div className="h-[500px] overflow-hidden rounded-2xl shadow-xl">
                            <img alt="" className="w-full h-full object-cover" src={photo1}/>
                        </div>
                        <div className="space-y-6">
                            <h3 className="text-3xl font-serif font-semibold text-brand-green mb-4">Our Culture</h3>
                            <p className="text-lg text-gray-700 leading-relaxed">
                                Οι δημιουργίες μας σχεδιάζονται ώστε να εξυπηρετούν την οργάνωση, συνδυάζοντας αρμονικά
                                τη διακόσμηση και την αισθητική του χώρου σας.
                                Επιθυμούμε να μοιραστούμε την οπτική και την αισθητική μας, αναδεικνύοντας την ποιότητα
                                του χειροποίητου, την πρακτικότητα και μια easy living φιλοσοφία.
                            </p>
                            <p className="text-lg text-gray-700 leading-relaxed">

                            </p>
                            <div className="flex items-start space-x-4 pt-4">
                                <div
                                    className="bg-brand-green text-white w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0">
                                    <i className="fas fa-leaf text-xl"></i>
                                </div>
                                <div>
                                    <h4 className="font-semibold text-lg mb-2">Natural Materials</h4>
                                    <p className="text-gray-600">Τα νήματα μας προέρχονται από ελληνική βιομηχανία
                                        κλωστοϋφαντουργίας και χρησιμοποιούμε νήματα όπως βαμβάκι και lurex με
                                        πιστοποίηση OEKTO-TEX STANDARD 100 ώστε να είναι ασφαλή για την ανθρώπινη υγεία.
                                        Όλα τα νήματα, από το κλασικό βαμβακερό έως το λαμπερό lurex, διατίθενται σε μια
                                        ευρεία γκάμα αποχρώσεων.</p>
                                </div>
                            </div>
                            <div className="flex items-start space-x-4">
                                <div
                                    className="bg-brand-green text-white w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0">
                                    <i className="fas fa-hands text-xl"></i>
                                </div>
                                <div>
                                    <h4 className="font-semibold text-lg mb-2">Handcrafted Excellence</h4>
                                    <p className="text-gray-600"> Κάθε καλάθι αφηγείται μια ιστορία αφοσίωσης, υπομονής
                                        και μαεστρίας και φτιάχνεται αποκλειστικά στο χέρι
                                        διασφαλίζοντας ότι κάθε καμπύλη και κάθε λεπτομέρεια ανταποκρίνεται στις
                                        προσδοκίες σας.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="basket-showcase" className="py-20 bg-white">
                <div className="max-w-7xl mx-auto px-6">
                    <div className="text-center mb-16">
                        <h2 className="text-5xl font-serif font-bold text-gray-800 mb-6">About Our Collection</h2>
                        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                            Σας παρουσιάζουμε τα χειροποίητα μας προϊόντα που περιλαμβάνουν βαμβακερά επιδαπέδια καλάθια
                            για οργάνωση με αισθητική, πλεκτά βάζα που προσθέτουν στη διακόσμηση του χώρου σας, άνετα
                            πλεκτά κρεβατάκια κατοικιδίων και χειροποίητες baby καλαθούνες, οι οποίες μετά τη χρήση τους
                            ώς λίκνο και πάρκο, μετατρέπονται σε καλαίσθητες λύσεις οργάνωσης και αποθήκευσης
                            παιχνιδιών, παραμένοντας ένα μοναδικό δώρο και υπέροχο ενθύμιο των πρώτων χρόνων του
                            παιδιού.
                        </p>
                    </div>


                </div>
            </section>
        </div>
    );
}

export default About;